import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./Notification.css";
import {
  withBase,
  ControlBox,
  Button,
  Table,
  Pagination,
  LayerPopup,
  PopupWrapper,
} from "components";
import { useSelector } from "react-redux";
import NotificationConditionBox from "./NotificationConditionBox";
import NotificationViewTable from "./NotificationViewTable";
import NotificationEditTable from "./NotificationEditTable";

const API = {
  LIST: {
    url: "api/v1/board/notification/list",
    method: "post",
  },
  READ: {
    url: "api/v1/board/notification/read",
    method: "post",
  },
  CREATE: {
    url: "api/v1/board/notification/create",
    method: "post",
  },
  UPDATE: {
    url: "api/v1/board/notification/update",
    method: "post",
  },
  DELETE: {
    url: "api/v1/board/notification/delete",
    method: "post",
  },
};

const Notification = (props) => {
  const cretFlag = useSelector((state) => state.user.get("cretFlag"));
  const [param, setParam] = useState({ pageNo: 1 });
  const [datas, setDatas] = useState([]);
  const [total, setTotal] = useState(0);
  const [layerType, setLayerType] = useState("");
  const [viewData, setViewData] = useState(null);

  useEffect(() => {
    list();
  }, [param]);

  const list = async () => {
    const { HttpRequest, searching } = props;
    searching(true);

    const { url, method } = API.LIST;
    console.log(param);
    const response = await HttpRequest.request(url, method, param);
    if (HttpRequest.hasError(response, true)) {
      setTotal(0);
      setDatas([]);
      searching(false);
      return;
    }
    setTotal(response.totalRowCnt);
    setDatas(response.ntfMtrTxnList);
    searching(false);
  };
  const edit = async ({ url, method }, data) => {
    const { HttpRequest } = props;
    const response = await HttpRequest.request(url, method, data);
    if (HttpRequest.hasError(response, true)) {
      return false;
    }
    setParam({
      ...param,
      pageNo: 1,
    });
    return true;
  };
  const handleClickSearch = (condition) => {
    setParam({
      ...condition,
      pageNo: 1,
    });
  };
  const handleDoubleClick = (index) => {
    setLayerType("view");
    setViewData(datas[index]);
  };
  const handleClickNew = () => {
    setLayerType("new");
  };
  const handleClickEdit = () => {
    setLayerType("edit");
  };
  const handleClickClose = () => {
    setLayerType("");
    setViewData(null);
  };
  const handleClickSave = async (layerType, data) => {
    let ret = false;
    let msg = "";
    console.log(data);
    switch (layerType) {
      case "new":
        ret = await edit(API.CREATE, data);
        msg = "신규등록되었습니다.";
        break;
      case "edit":
        ret = await edit(API.UPDATE, data);
        msg = "수정저장되었습니다.";
        break;
      case "del":
        if (window.confirm("해당 게시물을 삭제 하시겠습니까?")) {
          ret = await edit(API.DELETE, data);
          msg = "삭제되었습니다.";
        }
        break;
      default:
        console.log(layerType);
        break;
    }
    if (ret) {
      setLayerType("");
      setViewData(null);

      if (msg) props.toast.error(msg);
    }
  };

  return (
    <div className="Notification">
      <NotificationConditionBox onClickSearch={handleClickSearch} {...props} />
      {cretFlag && (
        <ControlBox>
          <Button className="insert" onClick={handleClickNew}>
            신규등록
          </Button>
        </ControlBox>
      )}
      <article className="grid_data">
        <div className="">
          <Table
            widths={["11%", "*", "25%", "12%"]}
            columns={["번호", "제목", "내용", "등록일"]}
            datas={
              datas &&
              datas.map((item, key) => {
                return (
                  <>
                    <td>{item.seq === 0 ? "[공지]" : item.seq}</td>
                    <td className="tal">{item.ntfTitle}</td>
                    <td className="tal">{item.ntfSbst}</td>
                    <td>{props.formatter(item.regDt, "date")}</td>
                  </>
                );
              })
            }
            onDoubleClick={handleDoubleClick}
          />
        </div>
      </article>
      {datas && datas.length > 0 && (
        <Pagination
          page={param.pageNo}
          total={total}
          row={15}
          pageCount={10}
          fetchData={(page) => {
            setParam({
              ...param,
              pageNo: page,
            });
          }}
        />
      )}
      <LayerPopup layerType={layerType} onClose={handleClickClose}>
        <PopupWrapper
          layerType={layerType}
          title={"공지사항"}
          viewTable={
            <NotificationViewTable
              layerType={layerType}
              viewData={viewData}
              onClose={handleClickClose}
              onEdit={handleClickEdit}
              onSave={handleClickSave}
              formatter={props.formatter}
              cretFlag={cretFlag}
            />
          }
          editTable={
            <NotificationEditTable
              viewData={viewData}
              layerType={layerType}
              onClose={handleClickClose}
              onSave={handleClickSave}
            />
          }
        />
      </LayerPopup>
    </div>
  );
};

Notification.propTypes = {};

export default withBase(Notification);
